export default {
  ratePlanType: {
    STANDARD: 'قياسي',
    BAR: 'أفضل سعر متاح',
    CORPORATE: 'للشركات',
    MEMBER: 'للأعضاء',
    PACKAGE: 'باقة',
    PROMOTIONAL: 'ترويجي',
    OTA: 'OTA',
    WHOLESALE: 'بالجملة',
    NEGOTIATED: 'تعاقدي',
    MIXED: 'سعر مختلط',
  },
} as const;
